import { PublicUploadEmployeePhotoForm } from 'components/publicUploadEmployeePhotoForm';
import { FC } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';

export const PublicUploadEmployeePhotoPage: FC = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route path=":userId" element={<PublicUploadEmployeePhotoForm />} />
    </Route>
  </Routes>
);
